import React, { useState } from 'react';
import type { ReleaseImage } from 'fym-shared/src/releases/types';
import { TypedMemo } from '../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the panel; each part uses its own slice of it */
import styles from './WhatsNew.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface Props {
  image: ReleaseImage;
  alt: string;
}

/**
 * The promo image of a story card, above the tag. The width and height reserve its box before
 * it loads. An image that fails to load goes away, and the card draws as it does without one.
 */
const WhatsNewStoryImageComponent: React.FC<Props> = ({ image, alt }) => {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return null;
  }
  return (
    <img
      className={styles.storyImage}
      src={image.url}
      width={image.width}
      height={image.height}
      alt={alt}
      loading="lazy"
      decoding="async"
      data-testid="e2e.whatsNew.storyCard.image"
      onError={() => setFailed(true)}
    />
  );
};

export const WhatsNewStoryImage = TypedMemo(WhatsNewStoryImageComponent);
